type EnvShape = {
  apiUrl: string;
  googleClientId: string;
  appName: string;
  pinflLength: number;
  enableDevLogin: boolean;
};

const required = (key: string, value: string | undefined): string => {
  if (!value || value.length === 0) {
    if (import.meta.env.DEV) {
      console.warn(`[env] Missing required env var: ${key}`);
    }
    return '';
  }
  return value;
};

export const env: EnvShape = {
  apiUrl: required('VITE_API_URL', import.meta.env.VITE_API_URL),
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '',
  appName: import.meta.env.VITE_APP_NAME ?? 'Japan Cargo',
  pinflLength: Number(import.meta.env.VITE_PINFL_LENGTH ?? 14),
  enableDevLogin: String(import.meta.env.VITE_ENABLE_DEV_LOGIN ?? 'false') === 'true',
};
